export default __webpack_public_path__ + "static/media/bp-logo-white.536a893e.png";